import { render, staticRenderFns } from "./BlytzIconInfo.vue?vue&type=template&id=fbde3d48&scoped=true"
import script from "./BlytzIconInfo.vue?vue&type=script&lang=js"
export * from "./BlytzIconInfo.vue?vue&type=script&lang=js"
import style0 from "./BlytzIconInfo.vue?vue&type=style&index=0&id=fbde3d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbde3d48",
  null
  
)

export default component.exports